import { mapLoadedObservable } from '../../rxjs';
import { first } from 'rxjs/operators';
import { createElement } from '../../incdom';
import './contact.scss';
var loadMap = function (index, mapinfo) {
    mapLoadedObservable
        .pipe(first(function (v) { return v === true; }))
        .subscribe(function () {
        var myLatlng = new google.maps.LatLng(mapinfo.latitude, mapinfo.longitude);
        var mapOptions = {
            zoom: mapinfo.zoom,
            center: myLatlng,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            // styles: [
            //     {featureType: <google.maps.MapTypeStyleFeatureType>"all", stylers: [{visibility: 'off'}]},
            //     {featureType: <google.maps.MapTypeStyleFeatureType>"landscape.natural", stylers: [{visibility: 'off'}]},
            //     {featureType: <google.maps.MapTypeStyleFeatureType>"road.highway", stylers: [{visibility: 'off'}]},
            //     {featureType: <google.maps.MapTypeStyleFeatureType>"water", stylers: [{visibility: 'on'}]},
            //     {elementType: <google.maps.MapTypeStyleElementType>"labels.text", stylers: [{visibility: 'off'}]},
            //   ]
        };
        var mapElement = document.getElementById("contact-map-" + index);
        if (mapElement !== null) {
            var map = new google.maps.Map(mapElement, mapOptions);
            new google.maps.Marker({
                position: myLatlng,
                map: map,
                title: mapinfo.title
            });
        }
    });
};
var contactPageContent = function (pageChangeObservable, ContactAddressList, contactForm) {
    createElement("render", null,
        createElement("div", { class: 'contact-wrapper' }, function () { return ContactAddressList.map(function (item, i) {
            typeof item === 'function' ?
                createElement("render", null,
                    createElement("div", { class: 'contact-page-row' }, item))
                : createElement("render", null,
                    createElement("div", { class: 'contact-address-row' },
                        createElement("div", { class: 'contact-details' },
                            item.title ? createElement("h2", null, item.title) : '',
                            function () { return item.details.map(function (rowItem) {
                                typeof rowItem === 'function' ?
                                    createElement("render", null, rowItem)
                                    : createElement("render", null,
                                        createElement("div", { class: 'contact-address contact-row' },
                                            function () { return rowItem.icon('#333'); },
                                            createElement("p", { class: 'contact-label' }, rowItem.label),
                                            createElement("p", { class: 'contact-row-content' }, rowItem.link
                                                ? createElement("fragment", null,
                                                    createElement("a", { class: 'contact-row-content-link', href: rowItem.link, target: '_blank', rel: 'noopener noreferrer' }, rowItem.linkText))
                                                : rowItem.linkText)));
                            }); }),
                        item.mapinfo ? createElement("div", { id: "contact-map-" + i, class: 'contact-map' }) : ''));
            // loadMap(i, item.mapinfo);
        }); }),
        function () { return contactForm(pageChangeObservable); });
    // NICE: Preload a low res image of the map
    // if (MapInfo) loadMap(MapInfo);
    ContactAddressList.map(function (item, i) {
        if ((typeof item !== 'function') && (item.mapinfo !== null)) {
            loadMap(i, item.mapinfo);
        }
    });
};
var contactPage = function (ContactAddressList, contactForm) {
    return ({
        content: [
            {
                pageLocation: 'contact',
                image: { imageName: 'banners/contact', title: 'Contact Us' },
                pageTitle: 'Contact',
                name: 'contact',
                content: function (pco) { return contactPageContent(pco, ContactAddressList, contactForm); }
            }
        ],
        subMenu: []
    });
};
export { contactPage,
// loadMap,
 };
//# sourceMappingURL=index.js.map